// extracted by mini-css-extract-plugin
export default {"portrait":"Report_portrait__3i8fB","modalContainer":"Report_modalContainer__6DfdG"};